if (window.calculatorsLoaded) {
  console.log("STC: Calculators JS already loaded, skipping execution.");
} else {
  window.calculatorsLoaded = true;

  // Helper function for Shopify-style rounding (round unit price first)
  function calculatePriceWithDiscount(quantity, basePrice, discountPercent) {
    if (isNaN(quantity) || quantity <= 0) return 0;
    if (isNaN(basePrice) || basePrice <= 0) return 0;
    if (isNaN(discountPercent)) discountPercent = 0;
    
    let unitPrice = basePrice * (100 - discountPercent) / 100;
    unitPrice = Math.ceil(unitPrice * 100) / 100;
    const totalPrice = quantity * unitPrice;
    return Math.round(totalPrice * 100) / 100;
  }

  function roundUnitPrice(price) {
    return Math.ceil(price * 100) / 100;
  }
  function roundTotal(total) {
    return Math.round(total * 100) / 100;
  }

  // ----- Helper: get discount tier based on quantity (for custom qty) -----
  function getDiscountForQuantity(qty) {
    if (qty >= 5000) return 88;
    if (qty >= 2000) return 87;
    if (qty >= 1000) return 85;
    if (qty >= 700) return 83;
    if (qty >= 500) return 80;
    if (qty >= 300) return 70;
    if (qty >= 200) return 65;
    if (qty >= 100) return 60;
    if (qty >= 50) return 47;
    if (qty >= 20) return 35;
    return 0;
  }

  // ----- Background highlight for quantity radios -----
  setTimeout(() => {
    document.querySelectorAll('input[name="quantity"]').forEach((radio) => {
      radio.addEventListener("change", function () {
        document.querySelectorAll(".quantity-options").forEach((option) => {
          option.style.background = "none";
        });
        if (this.checked) {
          const option = this.closest(".quantity-options");
          if (option) option.style.background = "#ececec";
        }
      });
      if (radio.checked) {
        const option = radio.closest(".quantity-options");
        if (option) option.style.background = "#ececec";
      }
    });
  }, 2000);

  // ----- Size dropdown behaviour -----
  setTimeout(() => {
    const sizeDropdown = document.querySelector(".size-dropdown");
    if (sizeDropdown) {
      sizeDropdown.addEventListener("click", function () {
        const sizeOptions = document.getElementById("size-options");
        if (sizeOptions) {
          sizeOptions.style.display = sizeOptions.style.display === "block" ? "none" : "block";
        }
      });
    }
    document.querySelectorAll('input[name="dimensions"]').forEach(function (radio) {
      function handleEvent() {
        const label = this.closest("label");
        if (!label) return;
        const selectedValue = label.textContent.trim();
        const dropdown = document.querySelector(".size-dropdown");
        if (dropdown) dropdown.textContent = selectedValue;
        const sizeOptions = document.getElementById("size-options");
        if (sizeOptions) sizeOptions.style.display = "none";
      }
      radio.addEventListener("change", handleEvent);
      radio.addEventListener("click", handleEvent);
    });
    const checkedRadio = document.querySelector('input[name="dimensions"]:checked');
    if (checkedRadio) {
      const label = checkedRadio.closest("label");
      if (label) {
        const firstSelectedValue = label.textContent.trim();
        const dropdown = document.querySelector(".size-dropdown");
        if (dropdown) dropdown.textContent = firstSelectedValue;
      }
    }
  }, 3000);

  // ----- Get variant from URL -----
  function getVariantFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variant = urlParams.get("variant");
    if (variant) {
      return parseInt(variant);
    } else {
      const varEl = document.querySelector("[var-id]");
      if (!varEl) return null;
      var firstvarient = varEl.getAttribute("var-id");
      const sizeLabel = document.querySelector("#size-options label");
      if (sizeLabel) {
        sizeLabel.click();
        const dropdown = document.querySelector(".size-dropdown");
        if (dropdown) dropdown.innerText = sizeLabel.innerText;
      }
      const qtyInputs = document.querySelectorAll('input[name="quantity"]');
      if (qtyInputs && qtyInputs.length > 4) {
        qtyInputs[4].click();
      }
      return parseInt(firstvarient);
    }
  }

  // ----- Get current base price (without discount) -----
  function getCurrentPrice() {
    try {
      const variantId = getVariantFromURL();
      if (!variantId || isNaN(variantId)) return 0;
      document.querySelectorAll('input[name="id"]').forEach(el => el.value = variantId);
      const priceElement = document.querySelector(`div[var-id="${variantId}"] span`);
      if (!priceElement) return 0;
      const priceText = priceElement.innerText.trim();
      const regex = /(\d+(?:[.,]\d+)?)/g;
      const matches = priceText.match(regex);
      let priceString = matches && matches[0] ? matches[0] : "0";
      priceString = priceString.replace(",", ".");
      const price = parseFloat(priceString);
      return isNaN(price) ? 0 : price;
    } catch (error) {
      console.error("Error in getCurrentPrice:", error);
      return 0;
    }
  }

  // ----- Update the custom quantity row's price and discount label -----
  function updateCustomQuantityPrice(quantity) {
    const customDynamicPriceDiv = document.querySelector('#quantity-options .dynamic_price[data-quantity="custom"]');
    if (!customDynamicPriceDiv) return;
    const basePrice = getCurrentPrice();
    if (isNaN(basePrice) || basePrice <= 0) return;
    
    let discount = getDiscountForQuantity(quantity);
    let unitPrice = basePrice * (100 - discount) / 100;
    unitPrice = Math.ceil(unitPrice * 100) / 100;
    let totalPrice = quantity * unitPrice;
    totalPrice = Math.round(totalPrice * 100) / 100;
    
    const isDiscounted = discount > 0;
    let priceHtml = isDiscounted
      ? `<div class="prices"><span class="discounted_price">€${totalPrice.toFixed(2)}</span></div>`
      : `<div class="prices"><span class="">€${totalPrice.toFixed(2)}</span><span class="discounted_price">&nbsp;</span></div>`;
    customDynamicPriceDiv.innerHTML = priceHtml;
    customDynamicPriceDiv.setAttribute("data-save", discount);
    
    const customSavingsDiv = document.querySelector('#quantity-options .dynamic_sav[data-save="custom"]');
    if (customSavingsDiv) {
      customSavingsDiv.innerHTML = discount > 0 ? `-${discount}%` : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
    }
    const customRadio = document.querySelector('#quantity-options input[type="radio"][value="custom"]');
    if (customRadio) customRadio.setAttribute("data-discount", discount);
  }

  // ----- Populate size and quantity options -----
  function populateOptions() {
    const sizeOptions = document.getElementById("size-options");
    const quantityOptions = document.getElementById("quantity-options");
    if (sizeOptions && quantityOptions) {
      if (typeof data !== 'undefined' && data.sizes) {
        data.sizes.forEach((size) => {
          const label = document.createElement("label");
          label.classList.add("size_options", "form__label");
          label.innerHTML = `<input type="radio" name="dimensions" value="${size.value}" onchange="toggleCustomSizeInput(this)" data-total="${size.total}" /> ${size.label}`;
          sizeOptions.appendChild(label);
        });
      }
      if (typeof data !== 'undefined' && data.quantities) {
        data.quantities.forEach((quantity, index) => {
          const isCustom = quantity.value === "custom";
          const discountValue = isCustom ? 0 : (quantity.discount || 0);
          const saveValue = isCustom ? 0 : (quantity.discount || 0);
          let dynamic_save = (quantity.discount && quantity.discount != 0 && !isCustom) ? `-${quantity.discount}%` : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
          const pcsText = !isCustom ? " pcs" : "";
          const div = document.createElement("div");
          div.innerHTML = `<label class="quantity-options form__label">
                            <div class="quantity-data">
                                <input class="radio-inp" type="radio" name="quantity" value="${quantity.value}" onchange="toggleCustomQuantityInput(this)" data-discount="${discountValue}" /> &nbsp; ${quantity.label}${pcsText}</div>
                            <div class="dynamic_price" data-quantity="${quantity.value}" data-save="${saveValue}"></div>
                            <div class="dynamic_sav dynamic_save_${index}" data-save="${quantity.value}">${dynamic_save}</div>
                          </label>`;
          quantityOptions.appendChild(div);
        });
      }
      const selectedVariantValue = getVariantFromURL();
      const selectedSizeValue = getSizeFromURL() || getSizeFromLocalStorage();
      let selectedQuantityValue = getQuantityFromURL() || getQuantityFromLocalStorage();
      if (selectedVariantValue) selectSizeBasedOnVariant(selectedVariantValue);
      if (selectedSizeValue) selectSizeBasedOnValue(selectedSizeValue);
      if (selectedQuantityValue) {
        if (typeof selectedQuantityValue === "string" && selectedQuantityValue.startsWith("custom:")) {
          const customQty = parseInt(selectedQuantityValue.split(":")[1]);
          const customRadio = document.querySelector('#quantity-options input[type="radio"][value="custom"]');
          if (customRadio) {
            customRadio.checked = true;
            toggleCustomQuantityInput(customRadio);
            const customInput = document.getElementById("custom-quantity-input");
            if (customInput) customInput.value = customQty;
            updateCustomQuantityPrice(customQty);
            updatePrice(customQty);
          }
        } else {
          selectQuantityBasedOnValue(selectedQuantityValue);
        }
      }
    }
  }

  // ----- Storage helpers -----
  function getSizeFromURL() { const urlParams = new URLSearchParams(window.location.search); return urlParams.get("size") || null; }
  function getQuantityFromURL() { const urlParams = new URLSearchParams(window.location.search); return urlParams.get("quantity") || null; }
  function getSizeFromLocalStorage() { return localStorage.getItem("selectedSize"); }
  function getQuantityFromLocalStorage() { return localStorage.getItem("selectedQuantity"); }
  function saveSizeToLocalStorage(size) { localStorage.setItem("selectedSize", size); }
  function saveQuantityToLocalStorage(quantity) { localStorage.setItem("selectedQuantity", quantity); }

  // ----- Selectors for size and quantity -----
  function selectSizeBasedOnVariant(variantValue) {
    const sizeRadios = document.querySelectorAll('#size-options input[type="radio"]');
    sizeRadios.forEach(radio => {
      if (parseInt(radio.getAttribute("data-total")) === variantValue) {
        radio.checked = true;
        toggleCustomSizeInput(radio);
      }
    });
  }
  function selectSizeBasedOnValue(sizeValue) {
    const sizeRadios = document.querySelectorAll('#size-options input[type="radio"]');
    sizeRadios.forEach(radio => {
      if (radio.value === sizeValue) {
        radio.checked = true;
        toggleCustomSizeInput(radio);
      }
    });
  }
  function selectQuantityBasedOnValue(quantityValue) {
    const quantityRadios = document.querySelectorAll('#quantity-options input[type="radio"]');
    quantityRadios.forEach(radio => {
      if (radio.value == quantityValue) {
        radio.checked = true;
        toggleCustomQuantityInput(radio);
      }
    });
  }

  // ----- Lamination checkbox -----
  const checkbox = document.getElementById("enable_lamination");
  function uncheckCheckbox() {
    if (!checkbox) return;
    checkbox.checked = false;
    checkbox.dispatchEvent(new Event("change"));
    checkbox.setAttribute("name", "properties[Pelliculage]");
  }
  if (checkbox) {
    uncheckCheckbox();
    checkbox.addEventListener("change", function () {
      var updatedP = getSizeFromLocalStorage();
      checkbox.setAttribute("name", "properties[Pelliculage]");
      const finalLami = document.querySelector("#final-lami");
      if (this.checked) {
        variantHandler(updatedP);
        if (finalLami) finalLami.innerHTML = "Oui";
        checkbox.value = "Oui";
      } else {
        variantHandler(updatedP);
        if (finalLami) finalLami.innerHTML = "Non";
        checkbox.value = "Non";
      }
    });
  }

  // ----- Update main total price (called on quantity change, custom input, etc.) -----
  function updatePrice(selectedQuantity) {
    try {
      let quantityNum = parseFloat(selectedQuantity);
      const selectedQuantityRadio = document.querySelector('#quantity-options input[type="radio"]:checked');
      let discount = 0;
      if (selectedQuantityRadio) {
        const radioValue = selectedQuantityRadio.value;
        if (radioValue === "custom") {
          const customInput = document.getElementById("custom-quantity-input");
          if (customInput && customInput.value) quantityNum = parseFloat(customInput.value);
          discount = getDiscountForQuantity(quantityNum);
        } else {
          if (isNaN(quantityNum)) quantityNum = parseFloat(radioValue);
          const discountAttr = selectedQuantityRadio.getAttribute('data-discount');
          if (discountAttr && discountAttr !== '0' && discountAttr !== 'null') discount = parseFloat(discountAttr);
        }
      }
      if (isNaN(quantityNum) || quantityNum <= 0) {
        const totalBig = document.querySelector("#total-big");
        if (totalBig) totalBig.innerHTML = "Invalid quantity";
        return;
      }
      let basePrice = getCurrentPrice();
      if (isNaN(basePrice)) basePrice = 0;
      if (isNaN(discount)) discount = 0;
      const totalPrice = calculatePriceWithDiscount(quantityNum, basePrice, discount);
      const totalBig = document.querySelector("#total-big");
      if (totalBig) totalBig.innerHTML = `€${totalPrice.toFixed(2)}`;
      const quantityElement = document.querySelector(".quantity__input");
      if (quantityElement) {
        quantityElement.value = quantityNum;
        quantityElement.setAttribute("value", quantityNum);
      }
      if (selectedQuantityRadio && selectedQuantityRadio.value === "custom") {
        saveQuantityToLocalStorage(`custom:${quantityNum}`);
      } else {
        saveQuantityToLocalStorage(quantityNum);
      }
    } catch (error) {
      console.error("Error in updatePrice:", error);
    }
  }

  // ----- Main variant handler (called when size or lamination changes) -----
  function variantHandler(sizeValue) {
    try {
      let variantInputs = document.querySelectorAll(".product-form__input--pill input");
      const lamiCheckbox = document.querySelector("#enable_lamination");
      if (lamiCheckbox && !lamiCheckbox.checked) {
        variantInputs = Array.from(variantInputs).filter(input => /^\d+$/.test(input.value));
      }
      if (!variantInputs || variantInputs.length === 0) return;
      const sizeNum = parseFloat(sizeValue);
      if (isNaN(sizeNum)) return;
      let closestSize = null;
      variantInputs.forEach(values => {
        let dataValue = parseInt(values.value, 10);
        if (!isNaN(dataValue)) {
          if (closestSize === null || (dataValue >= sizeNum && (closestSize < sizeNum || dataValue < closestSize))) {
            closestSize = dataValue;
          }
        }
      });
      if (closestSize === null) return;
      variantInputs.forEach(values => {
        let dataValue = parseInt(values.value, 10);
        if (dataValue === closestSize) {
          values.checked = true;
          const radioBtn = document.getElementById(values.id);
          if (radioBtn) {
            radioBtn.checked = true;
            const changeEvent = new Event("change", { bubbles: true, cancelable: true });
            radioBtn.dispatchEvent(changeEvent);
            radioBtn.click();
            setTimeout(() => {
              const regularPrice = getCurrentPrice();
              if (isNaN(regularPrice)) return;
              const selectedQuantityRadio = document.querySelector('#quantity-options input[type="radio"]:checked');
              let currentDiscount = 0, currentQuantity = 0;
              if (selectedQuantityRadio) {
                if (selectedQuantityRadio.value === "custom") {
                  const customInput = document.getElementById("custom-quantity-input");
                  currentQuantity = customInput ? parseFloat(customInput.value) : 0;
                  currentDiscount = getDiscountForQuantity(currentQuantity);
                } else {
                  currentQuantity = parseFloat(selectedQuantityRadio.value);
                  const discountAttr = selectedQuantityRadio.getAttribute('data-discount');
                  if (discountAttr && discountAttr !== '0' && discountAttr !== 'null' && discountAttr !== 'undefined') {
                    currentDiscount = parseFloat(discountAttr);
                  }
                }
              }
              document.querySelectorAll("#quantity-options .dynamic_price").forEach(d => {
                const previousSibling = d.previousElementSibling;
                let discount = parseFloat(d.getAttribute("data-save"));
                if (isNaN(discount)) discount = 0;
                const quantityAttr = d.getAttribute("data-quantity");
                let quantity;
                if (quantityAttr === "custom") {
                  const customInput = document.getElementById("custom-quantity-input");
                  quantity = customInput ? parseFloat(customInput.value) : 0;
                  discount = getDiscountForQuantity(quantity);
                } else {
                  quantity = parseFloat(quantityAttr);
                }
                if (isNaN(quantity) || quantity <= 0) return;
                let discountedPricePerUnit = (regularPrice * (100 - discount)) / 100;
                discountedPricePerUnit = Math.ceil(discountedPricePerUnit * 100) / 100;
                let total_price = quantity * discountedPricePerUnit;
                total_price = Math.round(total_price * 100) / 100;
                if (previousSibling && previousSibling.classList.contains("quantity-data")) {
                  const radioButton = previousSibling.querySelector('input[type="radio"]:checked');
                  if (radioButton) {
                    const totalBig = document.querySelector("#total-big");
                    if (totalBig) totalBig.innerHTML = `€${total_price.toFixed(2)}`;
                  }
                  const prevRadio = previousSibling.querySelector('input[type="radio"]');
                  if (prevRadio) prevRadio.setAttribute("data-final-price", `€${total_price.toFixed(2)}`);
                }
                const isDiscounted = discount > 0;
                let prices = isDiscounted
                  ? `<span class="discounted_price">€${total_price.toFixed(2)}</span>`
                  : `<span class="">€${total_price.toFixed(2)}</span><span class="discounted_price">&nbsp;</span>`;
                d.innerHTML = `<div class="prices">${prices}</div>`;
              });
              if (selectedQuantityRadio && !isNaN(currentQuantity) && currentQuantity > 0) {
                let discountedPricePerUnit = (regularPrice * (100 - currentDiscount)) / 100;
                discountedPricePerUnit = Math.ceil(discountedPricePerUnit * 100) / 100;
                let finalTotal = currentQuantity * discountedPricePerUnit;
                finalTotal = Math.round(finalTotal * 100) / 100;
                const totalBig = document.querySelector("#total-big");
                if (totalBig && !isNaN(finalTotal)) totalBig.innerHTML = `€${finalTotal.toFixed(2)}`;
              }
              if (selectedQuantityRadio && selectedQuantityRadio.value === "custom") {
                const customQty = currentQuantity;
                const customDiscount = getDiscountForQuantity(customQty);
                const customSavingsDiv = document.querySelector('#quantity-options .dynamic_sav[data-save="custom"]');
                if (customSavingsDiv) customSavingsDiv.innerHTML = customDiscount > 0 ? `-${customDiscount}%` : "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
              }
            }, 100);
          }
        }
      });
    } catch (error) {
      console.error("Error in variantHandler:", error);
    }
  }

  // ----- Custom size input handling -----
  function toggleCustomSizeInput(radio) {
    const customSizeInput = document.getElementById("custom-price-input");
    const customSize1 = document.getElementById("Custom_size1");
    const customSize2 = document.getElementById("Custom_size2");
    
    if (radio.value !== "custom") {
      const sizeParts = radio.value.split("x");
      const width = sizeParts[0]?.trim();
      const height = sizeParts[1]?.trim();
      if (customSize1) customSize1.value = width;
      if (customSize2) customSize2.value = height;
      if (customSize1) customSize1.dispatchEvent(new Event("input", { bubbles: true }));
      if (customSize2) customSize2.dispatchEvent(new Event("input", { bubbles: true }));
      radio.setAttribute("data-total", parseFloat(width) * parseFloat(height));
    } else {
      if (customSizeInput) customSizeInput.style.display = "flex";
      // Always compute data-total from current input values before reading it
      const v1 = parseFloat(customSize1?.value) || 10;
      const v2 = parseFloat(customSize2?.value) || 10;
      radio.setAttribute("data-total", v1 * v2);
      validateAndMultiply();
    }
    
    if (customSizeInput) customSizeInput.style.display = radio.value === "custom" ? "flex" : "none";
    
    const sizeValue = radio.getAttribute("data-total");
    variantHandler(sizeValue);
    saveSizeToLocalStorage(sizeValue);
    
    const finalSizeSpan = document.querySelector("#final-size");
    const finalSizeInput = document.querySelector("#final-size-input");
    if (finalSizeSpan) finalSizeSpan.innerHTML = `${customSize1?.value || ""}x${customSize2?.value || ""} cm`;
    if (finalSizeInput) finalSizeInput.value = `${customSize1?.value || ""}x${customSize2?.value || ""} cm`;
  }

  // ----- Custom size validation & price update -----
  function validateAndMultiply() {
    const input1 = document.getElementById("Custom_size1");
    const input2 = document.getElementById("Custom_size2");
    const err_size = document.getElementById("err_size");
    if (!input1 || !input2) return;
    
    let value1 = parseFloat(input1.value);
    let value2 = parseFloat(input2.value);
    
    if (isNaN(value1) || isNaN(value2)) {
      if (err_size) err_size.innerHTML = "Enter height & width";
      return;
    } else {
      if (err_size) err_size.innerHTML = "";
    }
    if (value1 < 2 || value1 > 60 || value2 < 2 || value2 > 60) {
      if (err_size) err_size.innerHTML = "La taille doit être comprise entre 2 et 60";
      return;
    } else {
      if (err_size) err_size.innerHTML = "";
    }
    
    let result = value1 * value2;
    
    const finalSizeSpan = document.querySelector("#final-size");
    const finalSizeInput = document.querySelector("#final-size-input");
    if (finalSizeSpan) finalSizeSpan.innerHTML = `${value1}x${value2} cm`;
    if (finalSizeInput) finalSizeInput.value = `${value1}x${value2} cm`;
    
    const customSizeRadio = document.querySelector('#size-options input[type="radio"][value="custom"]');
    if (customSizeRadio) customSizeRadio.setAttribute("data-total", result);
    
    variantHandler(result);
    saveSizeToLocalStorage(result);
  }

  // ----- Custom quantity input handling -----
  function toggleCustomQuantityInput(radio) {
    let customQuantityInput = document.getElementById("custom-quantity-input");
    let customQuantityText = document.getElementById("custom-quantity-text");
    let quantityInput = document.querySelector(".quantity__input"); // optional - may not exist on all templates
    let finalDays = document.getElementById("final-days");

    // Guard: only require customQuantityInput — quantityInput and finalDays are optional
    if (!customQuantityInput) return;

    function updateDays(quantity) {
      if (!finalDays) return;
      let days;
      const qtyNum = parseFloat(quantity);
      if (isNaN(qtyNum)) days = 4;
      else if (qtyNum < 200) days = 4;
      else if (qtyNum < 499) days = 5;
      else if (qtyNum < 999) days = 6;
      else days = 7;
      finalDays.innerHTML = days + " Jours";
    }

    if (radio.value === "custom") {
      customQuantityInput.style.display = "block";
      if (customQuantityText) customQuantityText.style.display = "block";
      const initialQty = 100;
      updateCustomQuantityPrice(initialQty);
      updatePrice(initialQty);
      const finalQtyElem = document.querySelector("#final-qty");
      if (finalQtyElem) finalQtyElem.innerHTML = initialQty;
      updateDays(initialQty);
      customQuantityInput.value = initialQty;
      // Update Shopify native quantity input if it exists
      if (quantityInput) {
        quantityInput.value = initialQty;
        quantityInput.setAttribute("value", initialQty);
      }
      const submitBtn = document.querySelector(".product-form__submit");
      // Clone to remove stale listeners before re-binding
      const newInput = customQuantityInput.cloneNode(true);
      customQuantityInput.parentNode.replaceChild(newInput, customQuantityInput);
      customQuantityInput = newInput;
      customQuantityInput.addEventListener("input", function() {
        let quantity = parseInt(customQuantityInput.value);
        let errorMessage = document.querySelector(".custom-error-msg");
        if (!errorMessage) {
          errorMessage = document.createElement("div");
          errorMessage.classList.add("custom-error-msg");
          errorMessage.style.color = "red";
          const targetElem = document.querySelector("#custom-quantity-text");
          if (targetElem) targetElem.before(errorMessage);
          else customQuantityInput.after(errorMessage);
        }
        if (quantity < 10 || isNaN(quantity)) {
          errorMessage.innerHTML = "la quantité doit être supérieure à 10";
          errorMessage.style.display = "block";
          if (submitBtn) submitBtn.disabled = true;
        } else {
          errorMessage.innerHTML = "";
          errorMessage.style.display = "none";
          const finalQtyElem = document.querySelector("#final-qty");
          if (finalQtyElem) finalQtyElem.innerHTML = quantity;
          updateCustomQuantityPrice(quantity);
          updatePrice(quantity);
          updateDays(quantity);
          if (submitBtn) submitBtn.disabled = false;
        }
      });
    } else {
      customQuantityInput.style.display = "none";
      if (customQuantityText) customQuantityText.style.display = "none";
      // Remove any error message when switching away from custom
      const errorMessage = document.querySelector(".custom-error-msg");
      if (errorMessage) { errorMessage.innerHTML = ""; errorMessage.style.display = "none"; }
      updatePrice(radio.value);
      const finalQtyElem = document.querySelector("#final-qty");
      if (finalQtyElem) finalQtyElem.innerHTML = radio.value;
      updateDays(radio.value);
      // Re-enable submit in case it was disabled
      const submitBtn = document.querySelector(".product-form__submit");
      if (submitBtn) submitBtn.disabled = false;
      setTimeout(() => {
        const currentSize = getSizeFromLocalStorage();
        if (currentSize) variantHandler(currentSize);
      }, 100);
    }
  }

  // Bind to window to ensure global access (crucial for inline onchange attributes)
  window.calculatePriceWithDiscount = calculatePriceWithDiscount;
  window.roundUnitPrice = roundUnitPrice;
  window.roundTotal = roundTotal;
  window.getDiscountForQuantity = getDiscountForQuantity;
  window.getVariantFromURL = getVariantFromURL;
  window.getCurrentPrice = getCurrentPrice;
  window.updateCustomQuantityPrice = updateCustomQuantityPrice;
  window.populateOptions = populateOptions;
  window.getSizeFromURL = getSizeFromURL;
  window.getQuantityFromURL = getQuantityFromURL;
  window.getSizeFromLocalStorage = getSizeFromLocalStorage;
  window.getQuantityFromLocalStorage = getQuantityFromLocalStorage;
  window.saveSizeToLocalStorage = saveSizeToLocalStorage;
  window.saveQuantityToLocalStorage = saveQuantityToLocalStorage;
  window.selectSizeBasedOnVariant = selectSizeBasedOnVariant;
  window.selectSizeBasedOnValue = selectSizeBasedOnValue;
  window.selectQuantityBasedOnValue = selectQuantityBasedOnValue;
  window.uncheckCheckbox = uncheckCheckbox;
  window.updatePrice = updatePrice;
  window.variantHandler = variantHandler;
  window.toggleCustomSizeInput = toggleCustomSizeInput;
  window.validateAndMultiply = validateAndMultiply;
  window.toggleCustomQuantityInput = toggleCustomQuantityInput;

  // ----- Global listeners for quantity changes -----
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('change', function(e) {
      if (e.target && e.target.getAttribute('name') === 'quantity') {
        setTimeout(() => {
          const currentSize = getSizeFromLocalStorage();
          if (currentSize) variantHandler(currentSize);
          else {
            const selectedQuantity = parseFloat(e.target.value);
            if (!isNaN(selectedQuantity)) updatePrice(selectedQuantity);
          }
        }, 100);
      }
    });
  });

  // Only run calculator setup if the target elements exist on the page
  const hasCalculator = document.getElementById("size-options") || document.getElementById("quantity-options") || document.querySelector(".calc");
  if (hasCalculator) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", populateOptions);
    } else {
      populateOptions();
    }

    // ----- Bind input events for custom size fields -----
    function bindCustomSizeInputs() {
      const input1 = document.getElementById("Custom_size1");
      const input2 = document.getElementById("Custom_size2");
      if (input1) input1.addEventListener("input", validateAndMultiply);
      if (input2) input2.addEventListener("input", validateAndMultiply);
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bindCustomSizeInputs);
    } else {
      bindCustomSizeInputs();
    }

    // ----- Image preview and shape handling -----
    document.addEventListener("DOMContentLoaded", function () {
      const previewContainer = document.querySelector(".image-preview-container");
      const previewImage = document.getElementById("image_preview");
      const customPhotoInput = document.getElementById("custom_photo");

      if (customPhotoInput && previewImage && previewContainer) {
        customPhotoInput.addEventListener("change", function (event) {
          const file = event.target.files[0];
          if (file) {
            const fileType = file.type;
            if (fileType.startsWith("image/")) {
              const reader = new FileReader();
              reader.onload = function (e) {
                previewImage.src = e.target.result;
                previewImage.style.display = "block";
                const shapeSelect = document.getElementById("stc-sticker-shape-select");
                const shape = shapeSelect ? shapeSelect.value : "circle";
                previewImage.classList.remove("sticker-circle", "sticker-square", "sticker-rectangle", "sticker-hexagon", "sticker-pentagon", "sticker-octagon", "sticker-diamond", "sticker-triangle", "sticker-star", "sticker-heart", "cover-mode");
                previewImage.classList.add("cover-mode");
                if (shape !== "none" && shape !== "contour") previewImage.classList.add("sticker-" + shape);
                previewContainer.style.borderStyle = "solid";
                previewContainer.style.borderColor = "#00b67a";
              };
              reader.readAsDataURL(file);
            } else if (fileType === "application/pdf") {
              previewImage.src = "https://cdn.shopify.com/s/files/1/0578/4882/3996/files/80942.png?v=1725791225";
              previewImage.style.display = "block";
              const shapeClasses = ["cover-mode", "sticker-circle", "sticker-square", "sticker-rectangle", "sticker-hexagon", "sticker-pentagon", "sticker-octagon", "sticker-diamond", "sticker-triangle", "sticker-star", "sticker-heart"];
              shapeClasses.forEach(cls => previewImage.classList.remove(cls));
              previewContainer.style.borderStyle = "solid";
            } else {
              previewImage.src = "https://cdn.shopify.com/s/files/1/0578/4882/3996/files/page-file-icon.webp?v=1725791274";
              previewImage.style.display = "block";
              const shapeClasses = ["cover-mode", "sticker-circle", "sticker-square", "sticker-rectangle", "sticker-hexagon", "sticker-pentagon", "sticker-octagon", "sticker-diamond", "sticker-triangle", "sticker-star", "sticker-heart"];
              shapeClasses.forEach(cls => previewImage.classList.remove(cls));
              previewContainer.style.borderStyle = "solid";
            }
          }
        });
        customPhotoInput.dispatchEvent(new Event('change'));
      }

      if (previewContainer && previewImage) {
        previewContainer.addEventListener("mouseenter", () => previewImage.style.transform = "scale(1.05)");
        previewContainer.addEventListener("mouseleave", () => previewImage.style.transform = "scale(1)");
      }

      const shapeSelect = document.getElementById("stc-sticker-shape-select");
      if (shapeSelect) {
        shapeSelect.addEventListener("change", function () {
          const shape = this.value;
          const previewImage = document.getElementById("image_preview");
          if (!previewImage) return;
          const shapeClasses = ["cover-mode", "sticker-circle", "sticker-square", "sticker-rectangle", "sticker-hexagon", "sticker-pentagon", "sticker-octagon", "sticker-diamond", "sticker-triangle", "sticker-star", "sticker-heart"];
          shapeClasses.forEach(cls => previewImage.classList.remove(cls));
          if (previewImage.src && !previewImage.src.includes("80942.png") && !previewImage.src.includes("page-file-icon.webp")) {
            previewImage.classList.add("cover-mode");
            if (shape !== "none" && shape !== "contour") previewImage.classList.add("sticker-" + shape);
          }
        });
      }
    });

    // ----- Modal for missing size -----
    document.addEventListener('DOMContentLoaded', () => {
      const sizeEl = document.querySelector('.size-dropdown');
      const stcWrapper = document.getElementById('stc-wrapper');
      if (!sizeEl || !stcWrapper) return;
      if (!stcWrapper.querySelector('.stc-click-blocker')) {
        const blocker = document.createElement('div');
        blocker.className = 'stc-click-blocker';
        stcWrapper.appendChild(blocker);
      }
      let modal = document.querySelector('.size-modal');
      if (!modal) {
        modal = document.createElement('div');
        modal.className = 'size-modal';
        modal.innerHTML = `<div class="size-modal-box"><h3>Select Size</h3><p>Please select size before continuing.</p><button id="size-modal-ok">OK</button></div>`;
        document.body.appendChild(modal);
      }
      const openModal = () => { modal.classList.add('active'); sizeEl.classList.add('indicate'); };
      const closeModal = () => { modal.classList.remove('active'); sizeEl.classList.remove('indicate'); };
      modal.addEventListener('click', e => { if (e.target === modal || e.target.id === 'size-modal-ok') closeModal(); });
      const toggleSTC = () => {
        const value = sizeEl.innerText.trim();
        if (value === '- × - cm') stcWrapper.classList.add('stc-disabled');
        else { stcWrapper.classList.remove('stc-disabled'); closeModal(); }
      };
      toggleSTC();
      new MutationObserver(toggleSTC).observe(sizeEl, { childList: true, characterData: true, subtree: true });
      const blocker = stcWrapper.querySelector('.stc-click-blocker');
      if (blocker) blocker.addEventListener('click', openModal);
    });

    // ----- FIX: Ensure custom quantity is sent to cart -----
    (function fixCustomQuantityOnSubmit() {
        const form = document.querySelector('form[action*="/cart/add"]') || 
                     document.querySelector('form.product-form') ||
                     document.querySelector('form[action^="/cart/add"]');
        
        if (!form) return;

        function updateAllQuantityFields(quantity) {
            const allQuantityInputs = form.querySelectorAll('input[name="quantity"]');
            allQuantityInputs.forEach(input => {
                input.value = quantity;
                input.setAttribute('value', quantity);
            });
            const visibleQty = document.querySelector('.quantity__input');
            if (visibleQty) visibleQty.value = quantity;
        }

        form.addEventListener('submit', function(e) {
            const selectedRadio = document.querySelector('#quantity-options input[type="radio"]:checked');
            if (!selectedRadio) return;

            let finalQuantity = null;

            if (selectedRadio.value === 'custom') {
                const customInput = document.getElementById('custom-quantity-input');
                if (customInput) {
                    finalQuantity = parseInt(customInput.value, 10);
                    if (isNaN(finalQuantity) || finalQuantity < 10) {
                        e.preventDefault();
                        alert('Please enter a valid quantity (minimum 10)');
                        return;
                    }
                }
            } else {
                finalQuantity = parseInt(selectedRadio.value, 10);
            }

            if (finalQuantity !== null && !isNaN(finalQuantity)) {
                updateAllQuantityFields(finalQuantity);
            }
        });
    })();
  }
}